import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import sv from './translations/sv.json';
import vi from './translations/vi.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      sv: { translation: sv },
      vi: { translation: vi },
    },
    lng: 'sv', // standard
    fallbackLng: 'sv',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
